import { ProductTileProps } from "../../../types";
export function sanitizeProductForNS(product) {
    const keysToKeep = [
        'articleCode',
        'availabilityStatus',
        'availableSizeOptionCodes',
        'availableSizeOptions',
        'availableVariantColorsCount',
        'availableVariants',
        'bluePrice',
        'brandName',
        'category',
        'clubPriceLabel',
        'hasPriceMarker',
        'imageModelAlt',
        'imageModelSrc',
        'imageProductAlt',
        'imageProductSrc',
        'initialFavouriteStatus',
        'isComingSoon',
        'isExternalBrand',
        'isNewProduct',
        'isOutOfStock',
        'markers',
        'marketingMarkerText',
        'marketingMarkerType',
        'pdpUrl',
        'priorPrice',
        'priorPriceLabel',
        'redPrice',
        'regularPrice',
        'showFavoriteButton',
        'swatches',
        'swatchesTotal',
        'title',
        'useModelAsDefault',
        'yellowPrice',
    ];
    const sanitizedProduct = {};
    keysToKeep.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(product, key)) {
            sanitizedProduct[key] = product[key];
        }
    });
    return sanitizedProduct;
}
//# sourceMappingURL=utils.js.map